import React from 'react';

function ViewUser({ user, closeModal }) {
  if (!user) return null;

  function formatDateTime(isoString) {
    const date = new Date(isoString);
    const formattedDate = date.toLocaleDateString();
    const formattedTime = date.toLocaleTimeString();
    return { date: formattedDate, time: formattedTime };
  }

  const url = 'uploads/';
  const { date, time } = formatDateTime(user.createdAt);

  const verifiedPillStyle = (value) => {
    const isValid = value === 'Valid';
    const isInvalid = value === 'Invalid';
    return {
      display: 'inline-block',
      padding: '2px 10px',
      borderRadius: '999px',
      fontWeight: 'bold',
      border: isValid
        ? '1px solid rgba(46, 181, 119, 0.45)'
        : isInvalid
          ? '1px solid rgba(239, 70, 86, 0.45)'
          : '1px solid rgba(0, 0, 0, 0.15)',
      color: isValid ? '#2eb577' : isInvalid ? '#ef4656' : 'inherit',
      background: isValid
        ? 'rgba(46, 181, 119, 0.12)'
        : isInvalid
          ? 'rgba(239, 70, 86, 0.12)'
          : 'transparent',
      lineHeight: 1.4,
    };
  };

  // Function to handle print
  const handlePrint = () => {
    window.print();
  };

  return (
    <div className="modal fade viewbox edit-box show d-block" id="manufacturerModal" tabIndex={-1} aria-labelledby="manufacturerModal" aria-hidden="true">
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="manufacturerModal">Details</h5>
            <button type="button" className="btn-close" onClick={closeModal} aria-label="Close"></button>
          </div>
          <div className="modal-body px-5">
            <div className="d-box ">
              <div className="d-flex justify-content-end align-items-center">
                <img src={user?.image ? `${process.env.REACT_APP_URL}${user?.image}` : 'img/profile-img.png'} alt="" style={{ height: '90px', width: '90px', objectFit: 'contain', marginRight: '100px', marginBottom: '20px' }} />
              </div>
              <ul className="d-flex list-unstyled flex-wrap justify-content-between">
                <li><span>Name: </span>{user.name}</li>
                <li><span>Age: </span>{user.age}</li>
                <li><span>Father's Name: </span>{user.fathersName}</li>
                <li><span>Mobile No: </span>{user.mobileNo}</li>
                <li><span>Gender: </span>{user.gender}</li>
                <li ><span>Aadhar No.: </span>{user.aadharNo}</li>
              </ul>

              <h6><span>Present Address:</span></h6>
              <ul className="d-flex list-unstyled flex-wrap justify-content-between">
                <li><span>Mohalla:</span> {user?.presentAddress?.mohalla}</li>
                <li><span>Ward:</span> {user?.presentAddress?.ward}</li>
                {/* <li><span>Village:</span> {user?.presentAddress?.village}</li> */}
                <li><span>Police Station:</span> {user?.presentPoliceStation?.name}</li>
                <li><span>District:</span> {user?.presentDistrict?.name}</li>
                <li><span>State:</span> {user?.presentState?.name}</li>
                <li><span>Pincode:</span> {user?.presentAddress?.pinCode}</li>
              </ul>

              <h6><span>Permanent Address:</span></h6>
              <ul className="d-flex list-unstyled flex-wrap justify-content-between">
                <li><span>Mohalla:</span> {user?.permanentAddress?.mohalla}</li>
                <li><span>Ward:</span> {user?.permanentAddress?.ward}</li>
                {/* <li><span>Village:</span> {user?.permanentAddress?.village}</li> */}
                <li><span>Police Station:</span> {user?.permanentPoliceStation?.name}</li>
                <li><span>District:</span> {user?.permanentDistrict?.name}</li>
                <li><span>State:</span> {user?.permanentState?.name}</li>
                <li><span>Pincode:</span> {user?.permanentAddress?.pinCode}</li>
              </ul>

              <ul className="d-flex list-unstyled flex-wrap justify-content-between">
                <li><span>Profession:</span> {user?.profession?.profession}</li>
                <li><span>Name of Shop:</span> {user?.profession?.nameOfShop}</li>
                <li><span>Owner Name:</span> {user?.profession?.ownerName}</li>
                <li><span>Address:</span> {user?.profession?.address}</li>
                <li><span>Mobile No:</span> {user?.profession?.mobileNo}</li>
                <li><span>Vehicle No:</span> {user?.profession?.vehicleNo}</li>
              </ul>

              <h6><span>Family Members:</span></h6>
              <ul className="list-unstyled">
                {user.familyMembers?.map((member) => (
                  <li key={member._id}>
                    <ul className="d-flex list-unstyled flex-wrap justify-content-between">
                      <li><span>Name:</span> {member.name}</li>
                      <li><span>Relation:</span> {member.relation}</li>
                      <li><span>Age:</span> {member.age}</li>
                      <li><span>Aadhar No:</span> {member.aadhar || 'N/A'}</li>
                      <li><span>Mobile No:</span> {member.mobileNo || 'N/A'}</li>
                      <li><span>Member Salary:</span> {member.memberSalary || 'N/A'}</li>
                      <li><span>Outside of UK:</span> {member.outside_of_uk || 'N/A'}</li>
                      <li><span>Occupation:</span> {member.occupation || 'N/A'}</li>
                    </ul>
                  </li>
                ))}
              </ul>

              <ul className="d-flex list-unstyled flex-wrap justify-content-between">
              <li>
                  <span>Verification Id:</span>
                  {user?.presentAddress?.policeStation?.code && user?.verificationId && user?.presentAddress?.district?.code
                    ? `${user.presentAddress.policeStation.code}${user.verificationId}${user.presentAddress.district.code}`
                    : user?.presentAddress?.policeStation?.code || user?.verificationId || user?.presentAddress?.district?.code
                      ? `${user.presentAddress.policeStation?.code || ''}${user.verificationId || ''}${user.presentAddress.district?.code || ''}`.trim()
                      : 'N/A'}
                </li>
              </ul>

              <ul className="d-flex list-unstyled flex-wrap justify-content-between">
                <li><span>ID Type:</span> {user?.idType}</li>
              </ul>

              <h6><span>Property Details:</span></h6>
              <ul className="d-flex list-unstyled flex-wrap justify-content-between">
                <li><span>Self Occupied Property:</span> {user?.selfOccupiedProperty}</li>
                <li><span>Registered House:</span> {user?.registeredHouse}</li>
                {user?.registeredHouse === 'Yes' && (
                  <li><span>Area of House:</span> {user?.areaOfHouse}</li>
                )}
                <li><span>Land Belongs to Department:</span> {user?.landBelongsToDepartment}</li>
                <li><span>Staying From:</span> {user?.stayingFrom}</li>
                <li><span>Property Details Verified:</span> <span style={verifiedPillStyle(user?.propertyDetailsVerified)}>{user?.propertyDetailsVerified || 'N/A'}</span></li>
                {user?.propertyDetails && (
                  <div>
                    <h6><span>Property Transaction Details:</span></h6>
                    {user.propertyDetails.result && user.propertyDetails.result.map((property, index) => (
                      <div key={index}>
                        <ul className="d-flex list-unstyled flex-wrap justify-content-between">
                          <li><span>District:</span> {property.District}</li>
                          <li><span>Location:</span> {property.location}</li>
                          <li><span>Khasra:</span> {property.khasra}</li>
                          <li><span>Khatoni:</span> {property.khatoni || 'N/A'}</li>
                          <li><span>Khewat:</span> {property.khewat || 'N/A'}</li>
                          <li><span>Registration Date:</span> {property.regdate}</li>
                          <li><span>Property Details Verified:</span> <span style={verifiedPillStyle(property?.propertyDetailsVerified)}>{property?.propertyDetailsVerified || 'N/A'}</span></li>
                        </ul>
                        <h6><span>Buyer Information:</span></h6>
                        <ul className="d-flex list-unstyled flex-wrap justify-content-between">
                          <li><span>Buyer Name:</span> {property.Buyer}</li>
                          <li><span>Buyer ID:</span> {property.Buyer_IDname}</li>
                          <li><span>Buyer Mobile:</span> {property.Buyer_mobileno}</li>
                        </ul>
                        <h6><span>Seller Information:</span></h6>
                        <ul className="d-flex list-unstyled flex-wrap justify-content-between">
                          <li><span>Seller Name:</span> {property.Seller}</li>
                          <li><span>Seller ID:</span> {property.Seller_IDname}</li>
                          <li><span>Seller Mobile:</span> {property.Seller_mobileno}</li>
                        </ul>
                      </div>
                    ))}
                    {user.propertyDetails.count && (
                      <ul className="d-flex list-unstyled flex-wrap justify-content-between">
                        <li><span>Total Records:</span> {user.propertyDetails.count}</li>
                      </ul>
                    )}
                  </div>
                )}
                {user?.selfOccupiedProperty === 'No' && (
                  <>
                    <li><span>Landlord Name:</span> {user?.landlordName}</li>
                    <li><span>Landlord Address:</span> {user?.landlordAddress}</li>
                    <li><span>Landlord Mobile No:</span> {user?.landlordMobileNo}</li>
                  </>
                )}
              </ul>

              <h6><span>Income Details:</span></h6>
              <ul className="d-flex list-unstyled flex-wrap justify-content-between">
                <li><span>Monthly Salary:</span> {user?.monthlySalary}</li>
                <li><span>Other Source of Income:</span> {user?.otherSourceOfIncome}</li>
                <li><span>Outside Uttarakhand Salary:</span> {user?.outsideUttarakhandSalary}</li>
              </ul>

              <h6><span>Bill Information:</span></h6>
              <ul className="d-flex list-unstyled flex-wrap justify-content-between">
                <li><span>Bill Connection Name:</span> {user?.billConnectionName}</li>
                <li><span>Bill Code:</span> {user?.billCode}</li>
                <li><span>Bill Verified:</span> <span style={verifiedPillStyle(user?.billVerified)}>{user?.billVerified || 'N/A'}</span></li>
              </ul>
              {user?.billDocument && (
                <ul className="d-flex list-unstyled flex-wrap justify-content-between">
                  <li><span>Bill Document:</span> 
                    <a href={process.env.REACT_APP_URL + user?.billDocument} target='_blank' rel="noopener noreferrer">
                      <img src={user?.billDocument ? `${process.env.REACT_APP_URL}${user?.billDocument}` : 'img/profile-img.png'} alt="Bill Document" style={{ height: '100px', width: '100px', objectFit: 'contain', marginLeft: '10px' }} />
                    </a>
                  </li>
                </ul>
              )}
              {user?.billInfo && (
                <div>
                  <h6><span>Bill Information Details:</span></h6>
                  <ul className="d-flex list-unstyled flex-wrap justify-content-between">
                    {Object.entries(user.billInfo).map(([key, value]) => (
                      <li key={key}><span>{key}:</span> {value || 'N/A'}</li>
                    ))}
                  </ul>
                </div>
              )}

              <h6><span>Water Information:</span></h6>
              <ul className="d-flex list-unstyled flex-wrap justify-content-between">
                <li><span>Water Connection Name:</span> {user?.waterConnectionName}</li>
                <li><span>Water Code:</span> {user?.waterCode}</li>
                <li><span>Water Verified:</span> <span style={verifiedPillStyle(user?.waterVerified)}>{user?.waterVerified || 'N/A'}</span></li>
              </ul>
              {user?.waterDocument && (
                <ul className="d-flex list-unstyled flex-wrap justify-content-between">
                  <li><span>Water Document:</span> 
                    <a href={process.env.REACT_APP_URL + user?.waterDocument} target='_blank' rel="noopener noreferrer">
                      <img src={user?.waterDocument ? `${process.env.REACT_APP_URL}${user?.waterDocument}` : 'img/profile-img.png'} alt="Water Document" style={{ height: '100px', width: '100px', objectFit: 'contain', marginLeft: '10px' }} />
                    </a>
                  </li>
                </ul>
              )}
              {user?.waterInfo && (
                <div>
                  <h6><span>Water Information Details:</span></h6>
                  <ul className="d-flex list-unstyled flex-wrap justify-content-between">
                    {Object.entries(user.waterInfo).map(([key, value]) => (
                      <li key={key}><span>{key}:</span> {value || 'N/A'}</li>
                    ))}
                  </ul>
                </div>
              )}

              <h6><span>Location Details:</span></h6>
              <ul className="d-flex list-unstyled flex-wrap justify-content-between">
                <li><span>GPS Latitude:</span> {user?.gps?.lat}</li>
                <li><span>GPS Longitude:</span> {user?.gps?.long}</li>
              </ul>

              <h6><span>Additional Documents:</span></h6>
              <ul className="d-flex list-unstyled flex-wrap justify-content-between">
                <li><span>Rashan Document:</span> {user?.rashanDocument}</li>
                <li><span>Suspicious Profile:</span> {user?.suspiciousProfile}</li>
              </ul>

              {/* Homestay Information */}
              <h6><span>Homestay Information:</span></h6>
              <ul className="d-flex list-unstyled flex-wrap justify-content-between">
                <li><span>Homestay Verified:</span> <span style={verifiedPillStyle(user?.homeStayVerified)}>{user?.homeStayVerified || 'N/A'}</span></li>
              </ul>
              {user?.homeStayInfo && (
                <div>
                  <h6><span>Homestay Information Details:</span></h6>
                  <ul className="d-flex list-unstyled flex-wrap justify-content-between">
                    {Object.entries(user.homeStayInfo).map(([key, value]) => (
                      <li key={key}><span>{key}:</span> {value || 'N/A'}</li>
                    ))}
                  </ul>
                </div>
              )}

              {user?.govtSchemes && user.govtSchemes.length > 0 && (
                <h6><span>Government Schemes:</span></h6>
              )}
              {user?.govtSchemes?.map((scheme, index) => (
                <div key={index}>
                  <h6><span>Scheme {index + 1}:</span></h6>
                  <ul className="d-flex list-unstyled flex-wrap justify-content-between">
                    <li><span>Scheme Name:</span> {scheme?.schemeName}</li>
                    <li><span>Scheme No:</span> {scheme?.schemeNo}</li>
                    <li><span>Scheme Verified:</span> <span style={verifiedPillStyle(scheme?.schemeVerified)}>{scheme?.schemeVerified || 'N/A'}</span></li>
                  </ul>
                  {scheme?.schemeInfo && (
                    <div>
                      <h6><span>Scheme Information Details:</span></h6>
                      <ul className="d-flex list-unstyled flex-wrap justify-content-between">
                        {Object.entries(scheme.schemeInfo).map(([key, value]) => (
                          <li key={key}><span>{key}:</span> {value || 'N/A'}</li>
                        ))}
                      </ul>
                    </div>
                  )}
                  {scheme?.schemeDocument && (
                    <ul className="d-flex list-unstyled flex-wrap justify-content-between">
                      <li><span>Scheme Document:</span> 
                        <a href={process.env.REACT_APP_URL + scheme?.schemeDocument} target='_blank' rel="noopener noreferrer">
                          <img src={scheme?.schemeDocument ? `${process.env.REACT_APP_URL}${scheme?.schemeDocument}` : 'img/profile-img.png'} alt="Scheme Document" style={{ height: '100px', width: '100px', objectFit: 'contain', marginLeft: '10px' }} />
                        </a>
                      </li>
                    </ul>
                  )}
                </div>
              ))}

              {user.userType !== 'customer' && (
                <div className="mt-5 d-box-grp">
                  <a href={process.env.REACT_APP_URL + user?.idPhoto?.front} target='_blank' rel="noopener noreferrer">                 
                  <img src={user?.idPhoto?.front ? `${process.env.REACT_APP_URL}${user?.idPhoto?.front}` : 'img/profile-img.png'} alt="" style={{ height: '200px', width: '200px', objectFit: 'contain', marginRight: '100px', marginBottom: '20px' }} />
                  </a>
                  <a href={process.env.REACT_APP_URL + user?.idPhoto?.back} target='_blank' rel="noopener noreferrer">
                  <img src={user?.idPhoto?.back ? `${process.env.REACT_APP_URL}${user?.idPhoto?.back}` : 'img/profile-img.png'} alt="" style={{ height: '200px', width: '200px', objectFit: 'contain', marginRight: '100px', marginBottom: '20px' }} />
                  </a>
                
                  {/* <a href={process.env.REACT_APP_URL + user?.signatureFinger} target='_blank' rel="noopener noreferrer">
                    <button className="document-update-btn"><img src="img/pdf.svg" alt="PDF" /> Signature</button>
                  </a> */}
                </div>
              )}
            </div>
            {/* Print Button */}
            {/* <div className="text-center mt-4">
              <button className="btn btn-primary" onClick={handlePrint}>Print</button>
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
}

export default ViewUser;
